const FavIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clip-path='url(#clip0_74492_422)'>
        <path
          d='M15.9582 6.13694C15.8528 5.81296 15.5655 5.58358 15.2268 5.55294L10.6081 5.13363L8.78275 0.860116C8.64798 0.546146 8.34134 0.343506 8.00002 0.343506C7.65871 0.343506 7.35194 0.546146 7.21803 0.860116L5.39268 5.13363L0.773216 5.55294C0.434587 5.58419 0.147839 5.81357 0.0418805 6.13694C-0.0634679 6.46092 0.0338237 6.81627 0.289932 7.04088L3.78132 10.1023L2.75189 14.6363C2.67657 14.9697 2.80597 15.3145 3.08258 15.5144C3.23127 15.6224 3.40595 15.6764 3.58125 15.6764C3.73188 15.6764 3.88264 15.6364 4.01729 15.5558L8.00002 13.1744L11.982 15.5558C12.2741 15.7304 12.6415 15.7144 12.9175 15.5144C13.1941 15.3145 13.3235 14.9697 13.2482 14.6363L12.2187 10.1023L15.7101 7.04088C15.9661 6.81627 16.0635 6.46165 15.9582 6.13694Z'
          fill='#FFB000'
        />
      </g>
      <defs>
        <clipPath id='clip0_74492_422'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FavIcon;
